module.exports = __webpack_public_path__ + "static/media/ENI.49321fee.svg";